"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guardLength = void 0;
const errors_1 = require("./errors");
function guardLength(withLength, expectedLength) {
    let actualLength = withLength.length || 0;
    if (actualLength != expectedLength) {
        throw new errors_1.ErrInvariantFailed(`wrong length, expected: ${expectedLength}, actual: ${actualLength}`);
    }
}
exports.guardLength = guardLength;
//# sourceMappingURL=assertions.js.map